/**
 * LinkButton — mono uppercase text action with a 1 px ink underline.
 * Used for inline secondary actions in cards (duplicate detector "Otevřít",
 * linked-context "Zrušit", etc.).
 *
 * Renders as `<button>` by default; pass `as="a"` + `href` for navigation.
 *
 * Source: .agents/design/project/artboard-radical-zakaznik-form.jsx:302-307
 */

import type {
  AnchorHTMLAttributes,
  ButtonHTMLAttributes,
  ReactNode,
} from 'react';

type Common = {
  children: ReactNode;
  className?: string;
};

type ButtonShape = Common &
  ButtonHTMLAttributes<HTMLButtonElement> & { as?: 'button' };
type AnchorShape = Common &
  AnchorHTMLAttributes<HTMLAnchorElement> & { as: 'a' };

type LinkButtonProps = ButtonShape | AnchorShape;

const CLS =
  'inline-block cursor-pointer border-0 bg-transparent border-b border-ink px-0 pb-px font-mono text-[10px] uppercase tracking-[0.06em] text-ink hover:text-accent-text hover:border-accent transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent focus-visible:outline-offset-2';

export function LinkButton(props: LinkButtonProps) {
  if (props.as === 'a') {
    const { as: _as, className = '', children, ...rest } = props;
    return (
      <a {...rest} className={`${CLS} ${className}`}>
        {children}
      </a>
    );
  }
  const { as: _as, className = '', children, type = 'button', ...rest } =
    props as ButtonShape;
  return (
    <button {...rest} type={type} className={`${CLS} ${className}`}>
      {children}
    </button>
  );
}
